import { request as baseRequest, RequestOptions } from '../legacy/index.ts'

export type LegacyRequestParams = {
  headers?: Record<string, string>
  body?: any
  type?: string
  method?: string
  mode?: string
  credentials?: string
} & { [s: string]: any }

async function requestCompat<BODY>(url: string, params: LegacyRequestParams, withToken: boolean): Promise<BODY> {
  const defaultParams = {
    type: 'json',
    method: 'GET',
    mode: 'cors',
    credentials: 'same-origin',
  }
  const options = { ...defaultParams, ...params, withToken } as any as RequestOptions

  try {
    const response = await baseRequest<BODY>(url, options)
    return response.doThrow().body
  } catch (error: any) {
    if ('body' in error) {
      // error from left.doThrow (response.ok === false)
      throw { statusCode: error.statusCode, url: error.url, error: error.body }
    }
    if ('response' in error) {
      // body parsing error
      throw { statusCode: error.response.status, url: error.response.url }
    }
    // some other error
    throw error
  }
}

export async function request<BODY>(url: string, params: LegacyRequestParams): Promise<BODY> {
  return requestCompat(url, params, false)
}

export async function requestWithAccessToken<BODY>(url: string, params: LegacyRequestParams): Promise<BODY> {
  return requestCompat(url, params, true)
}
